import CircularProgress from "@mui/material/CircularProgress";
import { styled, Box } from "@mui/material";

export const CircularLoader = () => {
  const BoxStyles = styled(Box)<any>`
    -webkit-backdrop-filter: blur(17px);
    backdrop-filter: blur(17px);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `;

  return (
    <BoxStyles>
      <CircularProgress color="secondary" />
    </BoxStyles>
  );
};
